import { createI18n } from 'vue-i18n'
import type { MessageSchema, SupportedLocale } from './types'
import en from './locales/en'
import es from './locales/es'
import de from './locales/de'

const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false, // Use Composition API mode
  locale: 'en' as SupportedLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    de
  }
})

export default i18n